import { component } from "picoapp";

export const storeLocatorButton = component((node) => {
  const upcCode = node.dataset.productLocatorUpc;
  if (!upcCode) return;
  const button = node.querySelector<HTMLButtonElement>("button");
  button.addEventListener("click", function (e) {
    e.preventDefault();
    try {
      window.basketful.openBasketful({
        productLocatorUpc: upcCode,
        productLocator: true,
      });
    } catch (e) {
      console.error(e);
    }
  });
});
